var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
export var Container = styled.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: 3.125rem;\n  border-radius: 4px;\n  align-items: center;\n  justify-content: center;\n  font-family: ", ";\n  background-color: ", ";\n  color: ", ";\n  width: 100%;\n  cursor: pointer;\n"], ["\n  height: 3.125rem;\n  border-radius: 4px;\n  align-items: center;\n  justify-content: center;\n  font-family: ", ";\n  background-color: ", ";\n  color: ", ";\n  width: 100%;\n  cursor: pointer;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fontFamily;
}, function (_a) {
    var theme = _a.theme;
    return theme.primaryColor;
}, function (_a) {
    var theme = _a.theme;
    return theme.buttonContentColor;
});
var templateObject_1;
